import React from 'react';
import "./Copyright.css";

export const Copyright = () => {
  return (
    <div class="copyright">
        <div class="copy">
            <div class="left-txt">
            © 2022 Phlox Digital Shop(wordpress themes to html. R.tharindu). All rights reserved.
        </div>
        <div class="right-txt">
            Privacy Policy . Term Condition
        </div>
        </div>
        
    </div>
  )
}

